(ns practitest.frontend.components2.container-card)

(defn container-card
  "A flexible card component
   Options:
   - :title - Card title (required)
   - :subtitle - Optional subtitle below title
   - :header-action - Optional component to render in top right (e.g., pagination, links)
   - :class - Optional additional CSS classes"
  [{:keys [title subtitle header-action class]} & children]
  [:div.pt-container-card
   {:class class}
   (when (or title subtitle header-action)
     [:div.pt-container-card-header
      [:div.pt-container-card-header-left
       [:h3.pt-container-card-title title]
       (when subtitle
         [:p.pt-container-card-subtitle subtitle])]
      (when header-action
        [:div.pt-container-card-header-right
         header-action])])
   (into [:div.pt-container-card-content]
         children)])
